import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = { class: "greetings" };
const _hoisted_2 = {
    version: "1.1",
    id: "Colour_on_dark",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "120px",
    height: "33px",
    viewBox: "0 0 120 33",
    style: { "enable-background": "new 0 0 120 33" },
    "xml:space": "preserve"
};
const _hoisted_3 = { class: "green" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'Greeting',
    props: {
        msg: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(), _createElementBlock("svg", _hoisted_2, [...(_cache[0] || (_cache[0] = [
                        _createElementVNode("path", {
                            fill: "#a4b33a",
                            class: "logo-white",
                            "stroke-width": "0.1",
                            "stroke-linecap": "round",
                            d: "M67.3,16.5c0,10.2-7.9,16.3-17.6,16.3s-17.6-6.1-17.6-16.3C32.2,6.5,40.1,0,49.8,0C59.4,0,67.3,6.5,67.3,16.5z\r\n\t    M43.8,16.6c0,3.6,2.4,6.1,5.9,6.1c3.5,0,5.9-2.5,5.9-6.1c0-3.4-2.3-6.2-5.9-6.2C46.1,10.5,43.8,13.3,43.8,16.6z"
                        }, null, -1 /* CACHED */),
                        _createElementVNode("path", {
                            fill: "#fff",
                            class: "logo-green",
                            "stroke-width": "0.1",
                            "stroke-linecap": "round",
                            d: "M32.3,0.5l-13.8,22l0.1,0.2c0.9-0.1,1.8-0.2,2.7-0.2h9.6v9.8H0l11.5-18.6c0.8-1.4,1.8-2.6,2.8-3.8l-0.2-0.1\r\n\t    c-0.9,0.2-1.8,0.4-2.7,0.4H2.7V0.5H32.3z M69.7,0.5h11.5v21.6H91v10.2H69.7V0.5z M120,0.5l-12.3,31.8h-9.8L85.6,0.5h12.1l4.2,14.5\r\n\t    c0.5,1.6,0.8,3.1,0.8,4.7h0.3c0-1.6,0.3-3.2,0.8-4.7l4.2-14.5H120z"
                        }, null, -1 /* CACHED */)
                    ]))])),
                _createElementVNode("h1", _hoisted_3, _toDisplayString(__props.msg), 1 /* TEXT */)
            ]));
        };
    }
});
